export function parseParams(textValue, paramObject) {
    return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
}
export function getValueOrDash(value) {
    return value && value.trim() ? value : '-';
}
export const isNumeric = (value) => !isNaN(value);
